const getUsersAPI = () => 'api/users';

const getUsersInfractionsAPI = (userId, startDate, endDate, timeZone, page, limit = 10) =>
  `api/users/infractions?userId=${userId}&dateStart=${startDate}&dateEnd=${endDate}&timezoneOffset=${timeZone}&page=${page}&limit=${limit}`;
const getUsersActivitiesAPI = (userId, dateStart, dateEnd, timezoneOffset, page) =>
  `api/users/user-activities?userId=${userId}&dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}&page=${page}&limit=10`;
const getUsersTaskHistoryAPI = (userId, dateStart, dateEnd, timezoneOffset, page, limit) =>
  `api/users/task-history?userId=${userId}&dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}&page=${page}&limit=${limit}`;
const getUsersCommissionHistoryAPI = (userId, dateStart, dateEnd, timezoneOffset, page, limit = 10) =>
  `api/users/commission-history?userId=${userId}&dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}&page=${page}&limit=${limit}`;
const getUsersActivityOverviewByIdAPI = (
  userId,
  dateStart,
  dateEnd,
  previousStartDate,
  previousEndDate,
  timezoneOffset,
  type = 'today',
) =>
  `api/users/user-activity-overview-by-id?userId=${userId}&dateStart=${dateStart}&dateEnd=${dateEnd}&previousStartDate=${previousStartDate}&previousEndDate=${previousEndDate}&timezoneOffset=${timezoneOffset}&type=${type}`;
const getUsersByBranchAPI = () => 'api/users/users-by-branch';
const getUsersActivityPageAPI = () => 'api/system/users-activity-type';

const getOverallUserActivityAPI = (pageNo, userId = '', activityType = '') => {
  if (userId && activityType) {
    return `api/users/user-activities?page=${pageNo}&limit=${10}&type=${activityType}&userId=${userId}`;
  }
  if (userId) {
    return `api/users/user-activities?page=${pageNo}&limit=${10}&userId=${userId}`;
  }
  if (activityType) {
    return `api/users/user-activities?page=${pageNo}&limit=${10}&type=${activityType}`;
  }
  return `api/users/user-activities?page=${pageNo}&limit=${10}`;
};

const createUserAPI = () => 'api/users';

// const updateUserAPI = (userId) => `api/users/${userId}`;

const updateMyProfileAPI = () => `api/users/update-profile`;

const disableUserAPI = (userId) => `api/users/${userId}`;

const employeeFileListAPI = (userId) => `api/users/employee-file/${userId}`;

const getAllUserStatsAPI = (roleId, branchId) =>
  `api/users/user-activity-overview-by-type?roleId=${roleId}&branchId=${branchId}&timezoneOffset=-5.5`;

// TODO: This endpoint is not in use. Delete it
const getUserDetailsModalAPI = (roleId, branchId, timezoneOffset, type, activityType) =>
  `/api/users/filter-users-by-activity-type?roleId=${roleId}&branchId=${branchId}&timezoneOffset=${timezoneOffset}&type=${type}&activityType=${activityType}`;

const getTimeSheetChangeLogAPI = (userId, shiftId) =>
  `/api/users/user-activities?type=timesheet&userId=${userId}&shiftId=${shiftId}`;

const resendPasswordEmailAPI = (userId) => `api/users/re-send-mail-to-user/${userId}`;
const resetStateAPI = (userId) => `api/users/reset-user-state/${userId}`;

export const humanResourcesEndpoints = {
  getTimeSheetChangeLogAPI,
  getUsersAPI,
  resetStateAPI,
  resendPasswordEmailAPI,
  getUsersInfractionsAPI,
  getUsersActivitiesAPI,
  getUsersTaskHistoryAPI,
  getUsersCommissionHistoryAPI,
  getUsersActivityOverviewByIdAPI,
  getUsersByBranchAPI,
  getUsersActivityPageAPI,
  getOverallUserActivityAPI,
  createUserAPI,
  // updateUserAPI,
  disableUserAPI,
  getAllUserStatsAPI,
  employeeFileListAPI,
  getUserDetailsModalAPI,
  updateMyProfileAPI,
};
